import config from '../config'
import GenericApiService from './generic-api-service'

const baseURL = config.urls.caregivers

const service = new GenericApiService(baseURL, '_id')
export default service
